module.exports = __webpack_public_path__ + "img/asia-admin06.d4fee60b.png";